<!--我的页面-->
<template>
	<div class="id">
		<div class="navBar" @click="$router.back()">
			<van-icon name="arrow-left" />
			{{ $t('充币') }}
		</div>
		<div class="title">{{ $t('选择币种') }}</div>
		<div class="currency" @click="showPicker = true">
			<div>{{ currency.text }}</div>
			<van-icon name="arrow-down" />
		</div>
		<div id="qrcode" class="qrcode"></div>
		<div class="title">{{ $t('充币地址') }}</div>
		<div class="currency">
			<div class="address">{{ currency.address }}</div>
			<div style="color: #07ecfe;" @click="copyText">{{ $t('复制') }}</div>
		</div>
		<div class="title">{{ $t('上传充值凭证') }}</div>
		<van-uploader v-model="fileList" :max-count="1" :after-read="afterRead" :preview-size="100"
			style="margin-top: 20px;" />
		<div class="title">{{ $t('充值金额') }}</div>
		<div class="universal">
			<van-field v-model="amount" :placeholder="$t('请输入充值金额')" :border="false" />
		</div>
		<van-button class="btn" type="primary" @click="submit">{{ $t('充值') }}</van-button>
		<!-- <van-image width="100%" src="https://shengge975.com/img/txt.ef7125b5.png" /> -->
		<div class="tipsBack">
			<div style="font-size: 18px;padding-bottom: 20px;">{{ $t('重要通知') }}</div>
			<div v-html="richtext"></div>
		</div>
		<div class="title">{{ $t('充值记录') }}</div>
		<div class="table">
			<!-- 表头 -->
			<van-row class="header">
				<van-col span="6" class="vanItem">{{ $t('币种') }}</van-col>
				<van-col span="6" class="vanItem">{{ $t('充值数量') }}</van-col>
				<van-col span="6" class="vanItem">{{ $t('状态') }}</van-col>
				<van-col span="6" class="vanItem">{{ $t('创建时间') }}</van-col>
			</van-row>
			<!-- 数据 -->
			<div class="scroll">
				<van-row v-for="item in users" :key="item.id" class="row">
					<van-col span="6" class="trade">
						{{ item.payment_name }}
					</van-col>
					<van-col span="6" class="trade">
						{{ item.amount }}
					</van-col>
					<van-col span="6" class="trade">
						{{ item.status_text }}
					</van-col>
					<van-col span="6" class="trade">
						{{ item.createtime_text }}
					</van-col>
				</van-row>
			</div>
		</div>
		<van-popup v-model="showPicker" position="bottom">
			<van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" :confirm-button-text="$t('确认')" :cancel-button-text="$t('取消')"/>
		</van-popup>

	</div>
</template>
<script>
import {
	get,
	post
} from '@/http/request'
import apis from '@/http/api'
import QRCode from 'qrcodejs2';
export default {
	components: {

	},
	data() {
		return {
			showPicker: false,
			columns: [],
			currency: {},
			richtext: '',
			users: [],
			fileList: [], // 存放上传的图片
			fullurl: '',
			amount: ''
		};
	},
	mounted() {
		this.getData()
		this.recharge()
	},
	beforeUnmount() { },
	methods: {
		async afterRead(file) {
			// 这里写上传逻辑，比如调接口
			const formData = new FormData();
			formData.append("file", file.file);
			// 模拟上传成功后，替换成服务器返回的 URL
			const res = await post(apis.upload, formData, {
				headers: {
					"Content-Type": "multipart/form-data"
				}
			})
			if (res.code == 1) {
				this.fileList = [{
					url: res.data.fullurl
				}];
				return
			}
		},
		async getData() {
			const res = await get(apis.getData)
			if (res.code == 1) {
				this.richtext = res.data.richtext
				this.columns = res.data.payment.map(item => ({
					text: item.name,
					...item
				}))
				this.currency = this.columns[0]
				this.qRCodeS()
				return
			}
		},
		//充值记录
		async recharge() {
			const res = await get(apis.rechargeList, {
				limit: 9999,
				showLoading: false
			})
			if (res.code == 1) {
				this.users = res.data.data
				return
			}
		},
		//充值提交
		async submit() {
			if (this.fileList.length == 0) {
				this.$toast(this.$t('请上传充值凭证'))
				return
			}
			const res = await post(apis.submit, {
				image: this.fileList[0].url,
				amount: this.amount,
				payment_id: this.currency.id
			})
			if (res.code == 1) {
				this.amount = ''
				this.fileList = []
				this.$toast(res.msg);
				setTimeout(() => {
					this.recharge()
				}, 1200)
				return
			}
		},
		//复印
		copyText() {
			const input = document.createElement("input");
			input.value = this.currency.address;
			document.body.appendChild(input);
			input.select();
			document.execCommand("copy"); // 执行复制
			document.body.removeChild(input);
			this.$toast(this.$t('复制成功'));
		},
		onConfirm(value) {
			// console.log(value);
			this.currency = value
			this.showPicker = false
			this.qRCodeS()
		},
		qRCodeS() {
			const parent = document.getElementById("qrcode")
			parent.innerHTML = ''
			this.$nextTick(() => {
				new QRCode("qrcode", {
					text: this.currency.address, // 二维码内容
					width: 160,
					height: 160,
					colorDark: "#000000",
					colorLight: "#ffffff",
					correctLevel: QRCode.CorrectLevel.H
				});
			})
		}
	},
};
</script>
<style lang="less" scoped>
::v-deep .van-cell {
	padding: 0;
}

.id {
	color: #fff;
	padding: 0 15px;
	padding-bottom: 20px;
	padding-top: 50px;
	font-size: 14px;

	.navBar {
		background-color: #090d13;
		padding: 15px 10px;
		font-size: 18px;
		font-weight: 700;
		border-radius: 4px;
	}

	.title {
		padding-top: 20px;
		font-size: 16px;
		font-weight: 700;
	}

	.table {
		background: #000;
		color: #fff;
		margin-top: 20px;
		font-size: 12px;

		.header {
			background: #1c222c;
			padding: 10px 0;
			border-radius: 5px;

			.vanItem {
				text-align: center;
			}
		}

		.scroll {
			overflow-y: auto;
			height: 45vh;
			scrollbar-width: none;
			/* Firefox */
			-ms-overflow-style: none;
			/* IE/Edge */
		}

		.row {
			border-bottom: 1px solid #222b39;
			padding: 10px 0px;
			display: flex;
			align-items: center;
			font-size: 11px;

			.trade {
				text-align: center;
			}
		}
	}

	.tipsBack {
		background-color: #171d28;
		padding: 20px;
		border-radius: 10px;
		margin-top: 10px;
	}

	.universal {
		padding: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border: 1px solid #3a3f47;
		margin-top: 10px;
		border-radius: 5px;

		.address {
			width: 85%;
			word-break: break-all;
		}
	}

	.btn {
		width: 100%;
		margin: 20px 0;
		background-color: #07ecfe;
		border-radius: 5px;
		color: #000;
	}

	.currency {
		padding: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border: 1px solid #3a3f47;
		margin-top: 10px;
		border-radius: 5px;

		.address {
			width: 85%;
			word-break: break-all;
		}
	}

	.qrcode {
		padding: 10px;
		margin-top: 20px;
		background-color: #fff;
		display: inline-block;
		border-radius: 10px;
	}


}
</style>